import { AttributesMixin, define } from "@type-r/models";

import { Invoice } from "./invoice";
import { getAuthorizationBearer, getPlatformCode } from "./endpoint";

export interface InvoiceEditDTO extends AttributesMixin<typeof InvoiceEditDTO> { }

@define
export class InvoiceEditDTO extends Invoice {
  
    async update(id: string, data, reload, validationData) {
        const url =  `/api/v1/assetmaster/Invoices/assets/${id}`
        const response = await fetch(url, {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': getAuthorizationBearer(),
                'X-Platform-Code': getPlatformCode()
            }),
            body: JSON.stringify(data)
        })
        if(response.status == 200 ) {
            validationData.set({})
            reload()
        }

        if(response.status == 400 ) {
            const errorsData = await response.json()
            validationData.set(errorsData.errors)
        }
    }
}